type ToastType = 'success' | 'error' | 'info' | 'warning';

export interface ToastItem {
  id: number;
  type: ToastType;
  message: string;
  durationMs?: number;
}

type Listener = (toasts: ToastItem[]) => void;

class ToastManager {
  private listeners: Set<Listener> = new Set();
  private toasts: ToastItem[] = [];
  private idSeq = 1;

  subscribe(listener: Listener) {
    this.listeners.add(listener);
    listener(this.toasts);
    return () => this.listeners.delete(listener);
  }

  private emit() {
    for (const l of this.listeners) l(this.toasts);
  }

  show(message: string, type: ToastType = 'info', durationMs = 4000) {
    const id = this.idSeq++;
    const toast: ToastItem = { id, type, message, durationMs };
    this.toasts = [...this.toasts, toast];
    this.emit();
    if (durationMs && durationMs > 0) {
      setTimeout(() => this.dismiss(id), durationMs);
    }
  }

  dismiss(id: number) {
    this.toasts = this.toasts.filter(t => t.id !== id);
    this.emit();
  }

  clear() {
    this.toasts = [];
    this.emit();
  }

  showError(message: string, durationMs = 5000) {
    this.show(message, 'error', durationMs);
  }

  showSuccess(message: string, durationMs = 3000) {
    this.show(message, 'success', durationMs);
  }
}

export const toast = new ToastManager();


